import React from "react";
import { siteUrl } from '../../../shared/utils/siteUrl';
import "./section-points-info.scss";
import Button from "../../../shared/components/atoms/button/button";
import { getTextButtonRedeemItNow, getTextEnjoyYourPointsPartOne, getTextEnjoyYourPointsPartTwo } from "../../../utils/getPointMessages";

const SectionPointsInfo = props => {

  const { mobile } = props;

  var whatCanWinLink = siteUrl + '/mis-puntos/que-puedo-ganar'

  const isPeru = process.env.LOCALE === 'es-PE'

  return (
    <div className="f-section-points-info-container">

      {/* {(!isLogin && !mobile) && <span className="f-circle">
                <span className="f-circle-child" />
            </span>} */}

      <div className="f-section-points-info-container-wrap">

        {!mobile && <div className="f-image-use-points" />}

        <div className="f-info-container">
          <div className="f-info-container-title">
            <h2>
              ¡{ process.env.LOCALE === "es-AR" || process.env.LOCALE === "es-PY" || process.env.LOCALE === "es-UY" ? "Disfrutá" : "Disfruta"} tus puntos al máximo!
            </h2>
          </div>
          <div className="f-info-container-description">            
            <p>
              {getTextEnjoyYourPointsPartOne(process.env.LOCALE)}
              <b className="f-prefer-spend"> {getTextEnjoyYourPointsPartTwo(process.env.LOCALE)}</b>
            </p>
          </div>
          {!isPeru && <Button
            className="primary-pink"
            title={getTextButtonRedeemItNow(process.env.LOCALE)}
            onClick={(e) => { e.preventDefault(); window.location = whatCanWinLink }}
          />}
        </div>
      </div>

      <span className={"f-curve-effect-end-section f-back-curve"}>
        <span className="f-curve-effect-end-section-child" />
      </span>
    </div>
  )
}

export default SectionPointsInfo;
